import React from 'react';

const PaperSizePanel = ({
  outputPaperSize,
  setOutputPaperSize,
  customPaperWidth,
  setCustomPaperWidth,
  customPaperHeight,
  setCustomPaperHeight,
  useMillimeters,
  setUseMillimeters,
  PAPER_SIZES
}) => {
  return (
    <div className="panel-content">
      <div className="input-group">
        <label>
          Output Paper Size:
          <select
            value={outputPaperSize}
            onChange={(e) => setOutputPaperSize(e.target.value)}
          >
            {Object.entries(PAPER_SIZES).map(([key, value]) => (
              <option key={key} value={key}>
                {value.name}
              </option>
            ))}
          </select>
        </label>
      </div>

      {outputPaperSize === 'CUSTOM' && (
        <>
          <div className="input-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={useMillimeters}
                onChange={(e) => setUseMillimeters(e.target.checked)}
              />
              Use millimeters
            </label>
          </div>

          <div className="input-group">
            <label>
              Width ({useMillimeters ? 'mm' : 'inches'}):
              <input
                type="number"
                step="0.1"
                min="0"
                value={customPaperWidth}
                onChange={(e) => setCustomPaperWidth(parseFloat(e.target.value))}
              />
            </label>
          </div>

          <div className="input-group">
            <label>
              Height ({useMillimeters ? 'mm' : 'inches'}):
              <input
                type="number"
                step="0.1"
                min="0"
                value={customPaperHeight}
                onChange={(e) => setCustomPaperHeight(parseFloat(e.target.value))}
              />
            </label>
          </div>
        </>
      )}
    </div>
  );
};

export default PaperSizePanel; 